import React, { useState } from 'react';
import { Col, Row, Breadcrumb, Table, Spin, Button } from 'antd';
import { ComplianceCols } from '../data/Columns';
import ComplianceForm from '../components/compliance/ComplianceForm';
import { fetchBlockchainData } from '../data/BlockchainApi';
import { message } from 'antd';
import ModalBox from '../components/compliance/ModalBox';

function Compliance() {
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({ lotNumber: '', region: '', status: '', gtin: '' });
    const [loading, setLoading] = useState(false);
    const [currentColumns, setCurrentColumns] = useState([]);
    const [modalVisible, setModalVisible] = useState(false); // State for modal visibility
    const [selectedRow, setSelectedRow] = useState(null); // State for selected row details
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });


    // Add the "Details" column dynamically
    const detailsColumn = {
        title: 'Details',
        key: 'details',
        render: (_, record) => (
            <Button type="link" onClick={() => openModal(record)} className="btnPrimary" style={{ padding: '16px 20px', backgroundColor: '#335001' , color: '#FFF'}}>
                View
            </Button>
        ),
        status: ['certification', 'verification'], 
    };

   
    const handleFinish = async () => {
        setLoading(true);

        if (!formData.region) {
            message.error("Region is required!");
            return;
        }

        if (!formData.lotNumber && !formData.status && !formData.gtin) {
            message.error("Lot Number, GTIN or Status are required!");
            return; 
        }

        try {
            const response = await fetchBlockchainData(formData.region, formData.status, formData.lotNumber, formData.gtin);
            if (response) {
                setData(response);

                const consortiumId = formData.region === 'univer' ? 103 : 102;

                const rowsWithConsortium = response.map((item, index) => ({
                    ...item,
                    consortiumId,
                    key: `${item.id}-${index}`
                }));

                setData(rowsWithConsortium);

                setPagination(prev => ({
                    ...prev,
                    total: rowsWithConsortium.length,
                }));

                const filteredColumns = ComplianceCols.filter(col =>
                    col.status.includes(formData.status)
                );

                if (['certification', 'verification', 'reception'].includes(formData.status)) {
                    filteredColumns.push(detailsColumn);
                }

                setCurrentColumns(filteredColumns);
            } else {
                message.error("No response from API.");
            }
        } catch (error) {
            console.error("An error occurred during the submission process:", error);
            message.error("An error occurred during the submission process:", error)
        } finally {
            setLoading(false);
        }
    };


    const openModal = (record) => {
        setSelectedRow(record); // Set the selected row data
        setModalVisible(true); // Show the modal
    };

    const closeModal = () => {
        setSelectedRow(null); // Clear the selected row data
        setModalVisible(false); // Hide the modal
    };


    const handleTableChange = (paginationConfig) => {
        setPagination(paginationConfig);
        window.scrollTo({ top: 300, behavior: 'smooth' });
    };


    
    return (
        <>
            <div className="breadcrumb" style={{ textAlign: 'left', marginBottom: '50px' }}>
                <h1 style={{ color: '#102F10' }}>
                    <Breadcrumb
                        items={[
                            {
                                title: <a href="/">Home</a>,
                            },
                            {
                                title: 'Compliance & Certification',
                            },
                        ]}
                    />
                </h1>
            </div>

            <Row gutter={[32, 24]}>
                <Col xs={24}>
                    <ComplianceForm formname="compliance_filter" formData={formData} setFormData={setFormData} onHndleFinish={handleFinish}/>
                </Col>
                <Col xs={24}>
                    <Spin spinning={loading} size="large">
                    {currentColumns.length > 0 ? (
                        <Table
                            columns={currentColumns} // Dynamically updated columns
                            dataSource={data}
                            pagination={{
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                total: pagination.total,
                                showSizeChanger: true,
                            }}
                            onChange={handleTableChange}
                            size="middle"
                            scroll={{ x: 800 }}
                        />
                    ) : (
                        <p>No data or columns to display</p> // Optional message when table is not rendered
                    )}
                    </Spin>
                </Col>
            </Row>   

            <ModalBox visible={modalVisible} data={selectedRow} onClose={closeModal} />    
        </>
    );
}

export default Compliance;
